var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const findDataByCode = ({ filterOptions, filterType, code }) => {
  let result = void 0;
  filterOptions.forEach((option) => {
    if (option.subItems && option.subItems.length !== 0) {
      const founded = option.subItems.find((e) => e.code === code);
      if (founded) {
        result = {
          filterType,
          option: founded
        };
      }
    }
    if (option.code === code) {
      result = {
        filterType,
        option
      };
    }
  });
  return result;
};
const updateAppliedFilters = ({ appliedFilters, setAppliedFilters, result }) => {
  const appliedFiltersKeys = Object.keys(appliedFilters);
  if (appliedFiltersKeys.length !== 0) {
    const newAppliedFilters = {};
    if (appliedFiltersKeys.find((e) => e === result.filterType)) {
      appliedFiltersKeys.forEach((filterType) => {
        if (filterType === result.filterType) {
          const presentObject = Object.keys(appliedFilters[filterType]).find((e) => e === result.option.code);
          if (!presentObject) {
            Object.assign(newAppliedFilters, {
              [filterType]: __spreadProps(__spreadValues({}, appliedFilters[filterType]), {
                [result.option.code]: {
                  name: result.option.name || "",
                  code: result.option.code || ""
                }
              })
            });
          }
        } else {
          Object.assign(newAppliedFilters, {
            [filterType]: __spreadValues({}, appliedFilters[filterType])
          });
        }
      });
    } else {
      Object.assign(newAppliedFilters, __spreadProps(__spreadValues({}, appliedFilters), {
        [result.filterType]: {
          [result.option.code]: {
            name: result.option.name,
            code: result.option.code
          }
        }
      }));
    }
    setAppliedFilters(newAppliedFilters);
  } else {
    setAppliedFilters({
      [result.filterType]: {
        [result.option.code]: {
          name: result.option.name,
          code: result.option.code
        }
      }
    });
  }
};

export { findDataByCode, updateAppliedFilters };
//# sourceMappingURL=helpers.es.js.map
